import _defineProperty from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["asChild"];
// src/primitive.tsx
import * as React from "react";
import * as ReactDOM from "react-dom";
import { createSlot } from "@radix-ui/react-slot";
import { jsx } from "react/jsx-runtime";
var NODES = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "select", "span", "svg", "ul"];
var Primitive = NODES.reduce(function (primitive, node) {
  var Slot = createSlot("Primitive.".concat(node));
  var Node = React.forwardRef(function (props, forwardedRef) {
    var asChild = props.asChild,
        primitiveProps = _objectWithoutProperties(props, _excluded);

    var Comp = asChild ? Slot : node;

    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }

    return /* @__PURE__ */jsx(Comp, _objectSpread(_objectSpread({}, primitiveProps), {}, {
      ref: forwardedRef
    }));
  });
  Node.displayName = "Primitive.".concat(node);
  return _objectSpread(_objectSpread({}, primitive), {}, _defineProperty({}, node, Node));
}, {});

function dispatchDiscreteCustomEvent(target, event) {
  if (target) ReactDOM.flushSync(function () {
    return target.dispatchEvent(event);
  });
}

var Root = Primitive;
export { Primitive, Root, dispatchDiscreteCustomEvent };